if(!customElements.get('product-discount-calculator')) {
    class ProductDiscountCalculator extends HTMLElement {
        constructor() {
            super();

            this.button_copy = this.querySelectorAll('[data-copy-code]');

            this.button_copy.forEach(el => {
                el.addEventListener('click', () => {
                    this.reset();
                    this.pushToDataLayer();

                    const code = el.getAttribute('data-copy-code');
                    if (!code) return;

                    const text_default = el.querySelector('.button__default');
                    const text_message = el.querySelector('.button__message');

                    // Optimistic UI toggle
                    if (text_default && text_message) {
                        text_default.classList.add('hidden');
                        text_message.classList.remove('hidden');
                    }

                    // Try modern clipboard API first, then fallback
                    this.copyToClipboard(code)
                        .catch(() => {
                            // keep success UI even if copy fails
                        })
                        .finally(() => {
                            setTimeout(() => {
                                if (text_default && text_message) {
                                    text_default.classList.remove('hidden');
                                    text_message.classList.add('hidden');
                                }
                            }, 3000);
                        });
                });
            });
        }

        copyToClipboard(text) {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                return navigator.clipboard.writeText(text);
            }
            // Fallback using a temporary textarea
            return new Promise((resolve, reject) => {
                try {
                    const textarea = document.createElement('textarea');
                    textarea.value = text;
                    textarea.setAttribute('readonly', '');
                    textarea.style.position = 'absolute';
                    textarea.style.left = '-9999px';
                    document.body.appendChild(textarea);
                    textarea.select();
                    const ok = document.execCommand('copy');
                    document.body.removeChild(textarea);
                    ok ? resolve() : reject(new Error('execCommand copy failed'));
                } catch (err) {
                    reject(err);
                }
            });
        }

        reset() {   
            document.querySelectorAll('.product__discount-calculator [data-copy-code]').forEach(el => {
                const text_default = el.querySelector('.button__default');
                const text_message = el.querySelector('.button__message');

                if (text_default && text_message) {
                    text_default.classList.remove('hidden');
                    text_message.classList.add('hidden');
                }
            });
        }

        pushToDataLayer() {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'discount_code_copied',
                'event_category': 'Product',
                'event_action': 'Copy Discount Code',
                'event_label': this.getAttribute('data-product-id')
            });
        }
    }

    customElements.define('product-discount-calculator', ProductDiscountCalculator);
}